import { useState } from 'react';
import { useTransition } from 'transition-hook';

import { Icon, Content, Block } from './help.styled';

export const Help = (props) => {
  const { info, children, className, timeout } = props;
  const [show, setShow] = useState(false);
  const { stage, shouldMount } = useTransition(show, timeout);
  const cl = stage + ' ' + (className ?? '');

  const initShow = () => {
    setShow(true);
  };

  const initHide = () => {
    setShow(false);
  };

  return (
    <Content>
      <Icon onMouseEnter={initShow} onMouseLeave={initHide}>
        {children}
      </Icon>
      {shouldMount && (
        <Block className={cl}>
          {info}
        </Block>
      )}
    </Content>
  );
};

Help.defaultProps = {
  children: '?',
  timeout: 100
};
